import { lmsFetchAPI } from "../../../../utils/axios";

const CONTENT_PATH = "/lms/content";

const toApiError = (error, fallback) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.error || fallback;
    return { status, message };
};

export const getContents = async () => {
    try {
        const response = await lmsFetchAPI.get(CONTENT_PATH);
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to load reading content");
    }
};

export const createContent = async (payload) => {
    try {
        const response = await lmsFetchAPI.post(CONTENT_PATH, payload);
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to create reading content");
    }
};

export const getContentById = async (contentId) => {
    try {
        const response = await lmsFetchAPI.get(`${CONTENT_PATH}/${contentId}`);
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to load reading content");
    }
};

export const updateContent = async (contentId, payload) => {
    try {
        const response = await lmsFetchAPI.put(`${CONTENT_PATH}/${contentId}`, payload);
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to update reading content");
    }
};

export const deleteContent = async (contentId) => {
    try {
        const response = await lmsFetchAPI.delete(`${CONTENT_PATH}/${contentId}`);
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to delete reading content");
    }
};
